module.exports = __webpack_public_path__ + "img/facts_1984.5a41b838.jpg";